import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29246_1159)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.1665 13.3333H3.49984C2.61611 13.3323 1.76888 12.9807 1.14398 12.3559C0.519092 11.731 0.167562 10.8837 0.166504 10L0.166504 3.33333C0.167562 2.4496 0.519092 1.60237 1.14398 0.97748C1.76888 0.352588 2.61611 0.00105857 3.49984 0L10.1665 0C11.0502 0.00105857 11.8975 0.352588 12.5224 0.97748C13.1473 1.60237 13.4988 2.4496 13.4998 3.33333V10C13.4988 10.8837 13.1473 11.731 12.5224 12.3559C11.8975 12.9807 11.0502 13.3323 10.1665 13.3333ZM3.49984 1.33333C2.9694 1.33333 2.4607 1.54405 2.08562 1.91912C1.71055 2.29419 1.49984 2.8029 1.49984 3.33333V10C1.49984 10.5304 1.71055 11.0391 2.08562 11.4142C2.4607 11.7893 2.9694 12 3.49984 12H10.1665C10.6969 12 11.2056 11.7893 11.5807 11.4142C11.9558 11.0391 12.1665 10.5304 12.1665 10V3.33333C12.1665 2.8029 11.9558 2.29419 11.5807 1.91912C11.2056 1.54405 10.6969 1.33333 10.1665 1.33333H3.49984ZM16.1665 12.6667V4C16.1665 3.82319 16.0963 3.65362 15.9712 3.5286C15.8462 3.40357 15.6766 3.33333 15.4998 3.33333C15.323 3.33333 15.1535 3.40357 15.0284 3.5286C14.9034 3.65362 14.8332 3.82319 14.8332 4V12.6667C14.8332 13.1971 14.6225 13.7058 14.2474 14.0809C13.8723 14.456 13.3636 14.6667 12.8332 14.6667H4.1665C3.98969 14.6667 3.82012 14.7369 3.6951 14.8619C3.57008 14.987 3.49984 15.1565 3.49984 15.3333C3.49984 15.5101 3.57008 15.6797 3.6951 15.8047C3.82012 15.9298 3.98969 16 4.1665 16H12.8332C13.7169 15.9989 14.5641 15.6474 15.189 15.0225C15.8139 14.3976 16.1654 13.5504 16.1665 12.6667Z",
			fill: "#1CB954"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29246_1159",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.166504)"
		})
	}) })]
});
export default SvgCopy;
